module.exports = __webpack_public_path__ + "img/SKMJ_standard4.e4fe2e88.png";